import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './colored_radio.less'

class ColoredRadio extends React.Component {
  static propTypes = {
    fieldProps: PropTypes.object,
    color: PropTypes.string,
  }

  isSelected = () => {
    return this.props.fieldProps.value === this.props.color
  }

  render() {
    const baseStyle = `colored-radio-${this.props.color}`
    const style = this.isSelected()
      ? `${baseStyle} colored-radio-selected`
      : baseStyle

    return (
      <div styleName={style}>
        <input
          type="radio"
          value={this.props.color}
          name={this.props.fieldProps.name}
          onChange={this.props.fieldProps.onChange}
          data-nemo={`pool-cover-${this.props.color}`}
          aria-label={this.props.color}
        />
      </div>
    )
  }
}

export default cssModules(ColoredRadio, styles, { allowMultiple: true })
